var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { API_URLS } from '../../constants/apiConstants';
import { GATEWAY_URL } from '../../utils/common/apiConfig';
import httpPost from '../../utils/http/httpPost';
/**
 * OTP 처리 결과를 요청합니다.
 *
 * @param requestParameter: 요청 파라미터
 * @param requestConfig: axios 요청 설정
 */
var fetchOtpResultUser = function (requestParameter, requestConfig) {
    var filledRequestConfig = __assign(__assign({}, requestConfig), { data: JSON.stringify(requestParameter) });
    return httpPost("".concat(GATEWAY_URL).concat(API_URLS.OTP_RESULT_USER), filledRequestConfig)
        .then(function (response) {
        return response;
    })
        .catch(function (e) {
        throw e;
    });
};
export default fetchOtpResultUser;
